import Constants from '@/Constants';
import { useHasModules } from '@/hooks/useHasModules';
import http from '@/services/HttpService';
import { ApplicationState } from '@/store';
import { default as React, useEffect, useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './style.scss';

const Dashboard: React.FC = () => {
    const { organizationId, strings } = useSelector((state: ApplicationState) => {
        return {
            organizationId: state.identity.data.user.orgId,
            strings: state.locale.data,
        };
    });
    const hasLms: boolean = false;
    const { hasPlaylist } = useHasModules();

    const authFormRef = useRef<HTMLFormElement>(null);
    const [formProperties, setFormProperties] = useState({ encryptedClaims: '', ssoProvider: '', targetUrl: '', iframeName: '' });

    const getDashboardRequest = (reportId: string) => {
        const dashboardRequest = Constants.DASHBOARD_URI.replace('%s', reportId).replace('%a', Constants.APP_ID.toString());

        http.get(dashboardRequest).then((response) => {
            const finalTargetUrl =
                response.data.targetUrl.replace('dashboard.html#', `dashboard.html?label.organizacao.organizacaoid=${organizationId}#`) +
                '&nochrome=true';

            setFormProperties({
                encryptedClaims: response.data.encryptedClaims,
                ssoProvider: response.data.ssoProvider,
                targetUrl: finalTargetUrl,
                iframeName: reportId,
            });
        });
    };

    useEffect(() => {
        getDashboardRequest(Constants.dashboards.CAST_DEFAULT);
    }, []);

    useEffect(() => {
        if (formProperties.iframeName) {
            authFormRef.current?.submit();
        }
    }, [formProperties.iframeName]);

    const onSelectTabHandler = (eventKey: string) => {
        getDashboardRequest(eventKey);
    };

    return (
        <div className="dashboard">
            <div className="dashboard-graphic-container">
                <form
                    action="https://afferolab.on.gooddata.com/gdc/account/customerlogin"
                    method="post"
                    ref={authFormRef}
                    target={formProperties.iframeName}
                >
                    <input id="targetUrl" name="targetUrl" type="hidden" value={formProperties.targetUrl} />
                    <input id="ssoProvider" name="ssoProvider" type="hidden" value={formProperties.ssoProvider} />
                    <input id="encryptedClaims" name="encryptedClaims" type="hidden" value={formProperties.encryptedClaims} />
                </form>
                <Tabs onSelect={(eventKey) => onSelectTabHandler(eventKey || '')} unmountOnExit>
                    <Tab eventKey={Constants.dashboards.CAST_DEFAULT} tabClassName="dashboard-graphic-container-tab" title={strings.GENERAL}>
                        <div>{<iframe className="dashboard-graphic-container-iframe" height={900} name={Constants.dashboards.CAST_DEFAULT} />}</div>
                    </Tab>
                    {hasLms && (
                        <Tab eventKey={Constants.dashboards.FLOW_LMS} tabClassName="dashboard-graphic-container-tab" title={strings.LMS}>
                            <div>{<iframe className="dashboard-graphic-container-iframe" height={600} name={Constants.dashboards.FLOW_LMS} />}</div>
                        </Tab>
                    )}
                    {hasPlaylist && (
                        <Tab eventKey={Constants.dashboards.FLOW_PLAYLIST} tabClassName="dashboard-graphic-container-tab" title={strings.PLAYLIST}>
                            <div>
                                {<iframe className="dashboard-graphic-container-iframe" height={1300} name={Constants.dashboards.FLOW_PLAYLIST} />}
                            </div>
                        </Tab>
                    )}
                </Tabs>
            </div>
        </div>
    );
};

export default Dashboard;
